import React from "react";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0 2rem 0;
  gap: 1rem;
  flex-wrap: wrap;
`;

const PaginationLink = styled(GatsbyLink)`
  padding: 0.5rem 1rem;
  color: #AD5843;
  text-decoration: none;
  font-family: Old Standard TT, serif;
  font-weight: bold;
  border: 1px solid transparent;
  border-radius: 4px;
  display: inline-block;
  
  &:hover {
    color: #AD5843;
    border-color: #AD5843;
    opacity: 0.8;
  }
`;

const CurrentPage = styled.span`
  padding: 0.5rem 1rem;
  color: #fff;
  background-color: #AD5843;
  font-family: Old Standard TT, serif;
  font-weight: bold;
  border-radius: 4px;
`;

const PaginationText = styled.span`
  color: #4c494f;
  font-family: Old Standard TT, serif;
`;

const Pagination = ({ currentPage, numPages }) => {
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? "/" : `/page/${currentPage - 1}/`;
  const nextPage = `/page/${currentPage + 1}/`;

  // Generate page numbers to show
  const getPageNumbers = () => {
    const delta = 2; // Number of pages to show around current page
    const range = [];
    const rangeWithDots = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(numPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      rangeWithDots.push(1, "...");
    } else {
      rangeWithDots.push(1);
    }

    rangeWithDots.push(...range);

    if (currentPage + delta < numPages - 1) {
      rangeWithDots.push("...", numPages);
    } else {
      rangeWithDots.push(numPages);
    }

    return rangeWithDots;
  };

  if (numPages <= 1) return null;

  const pageNumbers = getPageNumbers();

  return (
    <PaginationContainer>
      {!isFirst && (
        <PaginationLink to={prevPage}>
          ← Previous
        </PaginationLink>
      )}

      {pageNumbers.map((pageNum, index) => {
        if (pageNum === "...") {
          return (
            <PaginationText key={`dots-${index}`}>
              ...
            </PaginationText>
          );
        }

        if (pageNum === currentPage) {
          return (
            <CurrentPage key={pageNum}>
              {pageNum}
            </CurrentPage>
          );
        }

        const pageLink = pageNum === 1 ? "/" : `/page/${pageNum}/`;
        return (
          <PaginationLink key={pageNum} to={pageLink}>
            {pageNum}
          </PaginationLink>
        );
      })}

      {!isLast && (
        <PaginationLink to={nextPage}>
          Next →
        </PaginationLink>
      )}
    </PaginationContainer>
  );
};

export default Pagination;
